import React from "react";
import PropTypes from "prop-types";
import {
  TextField,
  FormGroup,
  FormControlLabel,
  List,
  ListItem,
  FormLabel,
  Grid,
  Checkbox,
  withStyles
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

import HoraireInformationsStyle from "./HoraireInformationsStyle";

import { WORK_DAYS } from "../../../../const";

const HoraireInformations = props => {
  const { values, handleChange, handleBlur, classes } = props;
  const { t } = useTranslation();

  return (
    <div>
      <h5>{t("add_kid.horaire_info.title")}</h5>

      <List>
        {WORK_DAYS.map(day => (
          <ListItem key={day}>
            <Grid container spacing={24}>
              <Grid item xs={6} sm={2}>
                <FormGroup>
                  <FormLabel className={classes.dayLabel}>{t(`days.${day}`, day)}</FormLabel>
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={`days[${day}][disable]`}
                        onChange={handleChange}
                        checked={values.days[day]["disable"]}
                        value={t("add_kid.horaire_info.closed")}
                      />
                    }
                    label={t("add_kid.horaire_info.closed")}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <TextField
                    type="Time"
                    variant="outlined"
                    disabled={values.days[day]["disable"]}
                    label={t("add_kid.horaire_info.arrival_time")}
                    name={`days[${day}][horaireDebutDto]`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.days[day]["horaireDebutDto"]}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6} sm={4}>
                <FormGroup>
                  <TextField
                    type="Time"
                    variant="outlined"
                    disabled={values.days[day]["disable"]}
                    label={t("add_kid.horaire_info.departure_time")}
                    name={`days[${day}][horaireFinDto]`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.days[day]["horaireFinDto"]}
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

HoraireInformations.propTypes = {
  values: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func
};

export default withStyles(HoraireInformationsStyle)(HoraireInformations);
